var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',{scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},[_c('agile',_vm._b({},'agile',_vm.agileOptions,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }